// extracted by mini-css-extract-plugin
module.exports = {"button":"header-button_button__TRtmJ","text":"header-button_text__20Shi","arrow":"header-button_arrow__3YRIu","arrowUp":"header-button_arrowUp__3bwSA"};